import Vue from "vue";
import VueRouter from "vue-router";
import { routes } from "./allRoutes";
Vue.use(VueRouter);

//register all routes here.
export default new VueRouter({
    base: __dirname,
    // mode: "history",
    routes: routes,
});




// import Vue from "vue";
// import VueRouter from "vue-router";
// Vue.use(VueRouter);

// //register all routes here.
// export default new VueRouter({
//     base: __dirname,
//     // mode: "history",
//     routes: routes,
//     routes: [{
//             name: "Login",
//             path: "/login",
//             component: require("../component/view/login/login.vue"),
//         },
//         {
//             name: "Login",
//             path: "/",
//             component: require("../component/view/login/login.vue"),
//         },
//         {
//             name: "dashboard",
//             path: "/dashboard",
//             component: require("../component/view/dashboard/dashboard.vue"),
//         },

//         {
//             name: "dashboard  Reports Details",
//             path: "/dashboard/dashboardReportsDetails/:filterId/:dateRange",
//             component: require("../component/view/dashboard/dashboardReportsDetails.vue"),
//         },
//         {
//             name: "dashboard  Reports Details",
//             path: "/dashboard/dashboardReportsDetails/:filterId",
//             component: require("../component/view/dashboard/dashboardReportsDetails.vue"),
//         },
//         {
//             name: "dashboard  Reports Exec Details",
//             path: "/dashboard/dashboardReportsExecList",
//             component: require("../component/view/dashboard/dashboardReportsExecList.vue"),
//         },

//         {
//             name: "Client Profile ",
//             path: "/dashboard/clientProfile",
//             component: require("../component/view/dashboard/clientProfile_reports.vue"),
//         },

//         {
//             name: "Client Report ",
//             path: "/dashboard/specificClientReports/:clientId",
//             component: require("../component/view/dashboard/specificClientReports.vue"),
//         },

//         {
//             name: "dashboard  Reports",
//             path: "/dashboard/dashboardReports",
//             component: require("../component/view/dashboard/dashboardReports.vue"),
//         },
//         {
//             name: "dashboard TPT Reports",
//             path: "/dashboard/dashboardTptReports",
//             component: require("../component/view/dashboard/dashboardTptReports.vue"),
//         },
//         {
//             name: "dashboard FF Export Reports",
//             path: "/dashboard/dashboardFfReports",
//             component: require("../component/view/dashboard/dashboardFfReports.vue"),
//         },

//         {
//             name: "dashboard CC Export Reports",
//             path: "/dashboard/dashboardCcImpoReports",
//             component: require("../component/view/dashboard/dashboardCcImpoReports.vue"),
//         },

//         {
//             name: "View Map",
//             path: "/map",
//             component: require("../component/view/vehicleMaster/map.vue"),
//         },
//         {
//             name: "Add Clients",
//             path: "/client/addClient",
//             component: require("../component/view/clients/addClient.vue"),
//         },
//         {
//             name: "Add Client Departments",
//             path: "/client/addClientDept",
//             component: require("../component/view/clients/addClientDept.vue"),
//         },
//         {
//             name: "Vehicle Quotation",
//             path: "/vehicle/quotation",
//             component: require("../component/view/vehicleQuotation/quotation.vue"),
//         },
//         {
//             name: "Transportation Email",
//             path: "/vehicleQuotation/tranportMailDetails",
//             component: require("../component/view/vehicleQuotation/tranportMailDetails.vue"),
//         },
//         {
//             name: "Transportation Email",
//             path: "/vehicleQuotation/vehicleDetailLocation",
//             component: require("../component/view/vehicleQuotation/vehicleDetailLocation.vue"),
//         },

//         {
//             name: "Vehicle Booking",
//             path: "/vehicle/vehicleBooking",
//             component: require("../component/view/vehicleQuotation/vehicleBooking.vue"),
//         },
//         {
//             name: "Job Order",
//             path: "/jobOrderSheet/jobOrderSheet",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/maintenance/jobOrderSheet/jobOrderSheet.vue"),
//         },
//         {
//             name: "Generate Invoice",
//             path: "/vehicle/invoice",
//             component: require("../component/view/vehicleQuotation/invoice.vue"),
//         },
//         {
//             name: "Vehicle Availability",
//             path: "/vehicle/vehicleAvailability",
//             component: require("../component/view/vehicleQuotation/vehicleAvailability.vue"),
//         },
//         {
//             name: "Goods Received",
//             path: "/vehicle/goodsReceived",
//             component: require("../component/view/vehicleQuotation/goodsReceived.vue"),
//         },
//         {
//             name: "Goods Received View",
//             path: "/vehicle/goodsReceived1",
//             component: require("../component/view/vehicleQuotation/goodsReceivedview.vue"),
//         },
//         {
//             name: "Hire Invoice",
//             path: "/hireInvoice",
//             component: require("../component/view/vehicleQuotation/hireInvoice.vue"),
//         },
//         {
//             name: "Detail Invoice",
//             path: "/viewHireInvoice",
//             component: require("../component/view/listView/viewHireInvoice.vue"),
//         },
//         {
//             name: "View Contract",
//             path: "/viewHireContract",
//             component: require("../component/view/clients/viewHireContract.vue"),
//         },
//         {
//             name: "Hire Model",
//             path: "/listView/hireModel",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/view/vehicleQuotation/hireModel.vue"),
//             departmentName: "Transportation",
//         },
//         {
//             name: "Maintenance & Repair",
//             path: "/yard/maintenance",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/yard/maintainRepair.vue"),
//         },
//         {
//             name: "Shipping Line Branch",
//             path: "/yard/newShippingBranch",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/yard/newShippingBranch.vue"),
//         },

//         {
//             name: "Item Used",
//             path: "/yard/editContainerRepair",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/yard/editContainerRepair.vue"),
//         },

//         {
//             name: "FF Execution ",
//             path: "/freightForward/ffExecution",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/ffExecution.vue"),
//         },
//         {
//             name: "FF Execution New",
//             path: "/freightForward/newffExecution",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/newffExecution.vue"),
//         },

//         {
//             name: "FF Booking ",
//             path: "/freightForward/ffBooking",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/ffBooking.vue"),
//         },
//         {
//             name: "FF Execution Warehouse",
//             path: "/freightForward/ffexecutionWareHouse",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/ffExecutionWareHouse.vue"),
//         },
//         {
//             name: "FF Execution Warehouse New",
//             path: "/freightForward/newFFExecutionWareHouse",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/newFFExecutionWareHouse.vue"),
//         },

//         {
//             name: "FF Execution Warehouse",
//             path: "/freightForward/ffSLinePaymentExport",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/ffSLinePaymentExport.vue"),
//         },
//         {
//             name: "FF Cons sline payment",
//             path: "/ffExportCon/ffConSLinePaymentExport",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/ffConSLinePaymentExport.vue"),
//         },

//         {
//             name: "Misc sline payment",
//             path: "/misc/slinePayment",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/miscSlinePayment.vue"),
//         },

//         {
//             name: "Misc Invoice",
//             path: "/misc/invoice",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/miscInvoiceDetails.vue"),
//         },

//         // {
//         //   name: "FF Cons sline payment Test",
//         //   path: "/ffExportCon/ffConSLinePaymentExportTest",
//         //   meta: {
//         //     auth: true,
//         //   },
//         //   component: require("../component/freightForwarding/ffConSLinePaymentExportN.vue"),
//         // },

//         {
//             name: "FF Execution Warehouse",
//             path: "/freightForward/ffSLinePaymentExportNew",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/ffSLinePaymentExportN.vue"),
//         },

//         {
//             name: "Misc Invoice Sline Payment",
//             path: "/misc/invoiceSlinePayment",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/miscInvoiceSlinePayment.vue"),
//         },

//         {
//             name: "Hand Over to Rail",
//             path: "/freightForward/handoverToRail",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/handoverToRail.vue"),
//         },
//         {
//             name: "Hand Over to Rail New",
//             path: "/freightForward/newHandoverToRail",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/newHandoverToRail.vue"),
//         },

//         {
//             name: "Sail and FPOD Detail",
//             path: "/freightForward/sailFPOD",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/sailFPOD.vue"),
//         },

//         {
//             name: "Sail and FPOD Detail",
//             path: "/freightForward/freightInvoiceForTally",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/freightInvoiceForTally.vue"),
//         },
//         {
//             name: "Sail and FPOD Con Detail",
//             path: "/freightForward/freightConInvoiceForTally/:conFclBLNonUsId",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/freightConInvoiceForTally.vue"),
//         },

//         {
//             name: "FFCon invoice Linear BL",
//             path: "/freightForward/freightConInvoiceForLinear/:conblLandingId",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/freightConInvoiceForLinear.vue"),
//         },
//         {
//             name: "Billing",
//             // path: "/allModuleForm/billing",
//             path: "/allModuleForm/billing/:billingId",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/TallyBillingMerge.vue"),
//         },

//         {
//             name: "Consolidation Billing",
//             // path: "/allModuleForm/billing",
//             path: "/consolidation/viewBillingDetails/:billingId",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/viewConBillingDetails.vue"),
//         },

//         {
//             name: "Billing New",
//             // path: "/allModuleForm/billing",
//             path: "/allModuleForm/newTallyBillingMerge/:billingId",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/newTallyBillingMerge.vue"),
//         },
//         {
//             name: "Multi Billing New",
//             path: "/allModuleForm/newTallyMultiBillingMerge/",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/newTallyMultiBillingMerge.vue"),
//         },
//         {
//             name: "Billing Con New",
//             // path: "/allModuleForm/billing",
//             path: "/allModuleForm/newTallyConBillingMerge/:billingId",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/newTallyConBillingMerge.vue"),
//         },

//         {
//             name: "View Billing Details",
//             path: "/allModuleForm/invoiceBilling/:billingId",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/viewTallyBillingDetails.vue"),
//         },

//         {
//             name: "Docs",
//             // path: "/allModuleForm/billing",
//             path: "/allModule/docs/:moduleId",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/docLibrary.vue"),
//         },
//         {
//             name: "Manual Billing",
//             // path: "/allModuleForm/billing",
//             path: "/allModuleForm/manualBill",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/manualTallyBilling.vue"),
//         },

//         // {
//         //   name: "Invoice For Tally",
//         //   path: "/freightForward/freightInvoiceForTally",
//         //   meta: {
//         //     auth: true
//         //   },
//         //   component: require("../component/freightForwarding/freightInvoiceForTally.vue")
//         // },
//         {
//             name: "VGM",
//             path: "/freightForward/vgmDetail",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/vgmDetail.vue"),
//         },
//         {
//             name: "VGM New",
//             path: "/freightForward/newVgmDetail",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/newVgmDetail.vue"),
//         },

//         {
//             name: "FF Export List New",
//             path: "/freightForward/newViewffExportFcl",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/newViewffExportFcl.vue"),
//         },

//         {
//             name: "FCL Bill of Landing ",
//             path: "/freightForward/fclBLofLanding",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/fclBLofLanding.vue"),
//         },
//         {
//             name: "BL Other US ",
//             path: "/freightForward/BL-US",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/BLOtherUsNew.vue"),
//         },

//         {
//             name: "BL Non Other US ",
//             path: "/freightForward/BL-NonUS",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/BLOtherNonUs.vue"),
//         },

//         {
//             name: "FCL Consolidation Booking Order",
//             path: "/ffExportCon/fclConsoBookingOrder",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/ffExportCon/fclConsoBookingOrder.vue"),
//         },

//         {
//             name: " Execution ­ W/H stuffing at ICD",
//             path: "/ffExportCon/executionWHStuffingIcdCon",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/ffExportCon/executionWHStuffingIcdCon.vue"),
//         },
//         {
//             name: "Sail and FPOD Detail",
//             path: "/freightForward/sailFPOD",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/sailFPOD.vue"),
//         },

//         {
//             name: "FCL  Export Consolidation VGM",
//             path: "/ffExportCon/fclConsoVgm",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/ffExportCon/fclConsoVgm.vue"),
//         },
//         {
//             name: "FCL  Export Consolidation HandoverRail",
//             path: "/ffExportCon/fclConsoHandOverToRail",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/ffExportCon/fclConsoHandOverToRail.vue"),
//         },
//         {
//             name: "FCL  Export Consolidation Sail & FPOD",
//             path: "/ffExportCon/consoFclSailFpod",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/ffExportCon/consoFclSailFpod.vue"),
//         },
//         {
//             name: " FCL Consolidation BL ",
//             path: "/ffExportCon/conFclBLofLanding",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/ffExportCon/conFclBLofLanding.vue"),
//         },
//         {
//             name: " FCL Consolidation BL(NON-US) ",
//             path: "/ffExportCon/conBLNonUs",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/ffExportCon/conBLNonUs.vue"),
//         },
//         {
//             name: " FCL Consolidation New BL(NON-US) ",
//             path: "/ffExportCon/conBLNewNonUs",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/ffExportCon/conBLNewNonUs.vue"),
//         },
//         {
//             name: " FCL Consolidation BL US ",
//             path: "/ffExportCon/conBLUs",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/ffExportCon/conBLNewUs.vue"),
//         },
//         {
//             name: " FCL Consolidation Sline BL US ",
//             path: "/ffExportCon/conBLSlineUs",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/ffExportCon/conBLNewSlineUs.vue"),
//         },
//         {
//             name: "Update Package",
//             path: "/airfreight/updatePackageExection",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/airFreight/updatePackageExection.vue"),
//         },
//         {
//             name: " Air Freight Booking ",
//             path: "/airfreight/airFreightBooking",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/airFreight/AirFreightBooking.vue"),
//         },
//         {
//             name: " Air Freight Execution ",
//             path: "/airfreight/airFreightExecution",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/airFreight/AirFreightExecution.vue"),
//         },

//         {
//             name: " Air Freight Tracking ",
//             path: "/airfreight/airTrackingFFExport",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/airFreight/airTrackingFFExport.vue"),
//         },
//         {
//             name: "Consol Master Merger",
//             path: "/airFreight/cansolMasterMerge",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/airFreight/cansolMasterMerge.vue"),
//         },
//         {
//             name: " AMS Filling",
//             path: "/ffExportCon/conAmsFilling",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/ffExportCon/amsFilling.vue"),
//         },
//         {
//             name: " AMS Filling",
//             path: "/freightForwarding/amsFilingNormal",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/amsFilingNormal.vue"),
//         },
//         {
//             name: " ISF Form",
//             path: "/freightForwarding/normalIsfExport",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/normalIsfExport.vue"),
//         },

//         {
//             name: " ISF Form  ",
//             path: "/ffExportCon/isfForm",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/ffExportCon/isfForm.vue"),
//         },
//         {
//             name: "Normal Sea Import Execution",
//             path: "/seaImport/ffSeaImportExecution",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/seaImport/ffSeaImportExecution.vue"),
//         },
//         {
//             name: "Documentation",
//             path: "/seaImport/documentation",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/seaImport/ImportDocumentation.vue"),
//         },
//         {
//             name: "Documentation Do",
//             path: "/seaImport/documentationDo",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/seaImport/ImportDOorderDocumentation.vue"),
//         },
//         {
//             name: "Documentation Cargo",
//             path: "/seaImport/ImportCargoDocNormal",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/seaImport/ImportCargoDocNormal.vue"),
//         },
//         {
//             name: "Documentation Cargo",
//             path: "/seaImport/ImportNOCDocNormal",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/seaImport/ImportNOCDocNormal.vue"),
//         },

//         {
//             name: "Normal Sea Import Tracking",
//             path: "/seaImport/seaImportNormalTrack",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/seaImport/seaImportNormalTrack.vue"),
//         },
//         {
//             name: "Invoice For Tally",
//             path: "/seaImport/freightInvoiceForTallyImport",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/seaImport/freightInvoiceForTallyImport.vue"),
//         },

//         {
//             name: "Air Import Tracking",
//             path: "/airImport/airImportTracking",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/airImport/airImportTracking.vue"),
//         },
//         {
//             name: "Air Import Exec",
//             path: "/airImport/airImportExec",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/airImport/airImportExec.vue"),
//         },
//         {
//             name: "Air Noc",
//             path: "/airImport/documentation",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/airImport/airNocImportDocumentation.vue"),
//         },
//         {
//             name: "Air Noc",
//             path: "/airImport/DOorderDocumentation",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/airImport/airImportDOorderDocumentation.vue"),
//         },
//         {
//             name: "Conso Sea Import Exec",
//             path: "/conSeaImport/ffConSeaImportExec",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/conSeaImport/ffConSeaImportExec.vue"),
//         },
//         {
//             name: "Noc Doc",
//             path: "/SeaImport/ConNocdoc",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/conSeaImport/seaConNocImportDocumentation.vue"),
//         },
//         {
//             name: "Cargo Doc",
//             path: "/SeaImport/ConSeaImpDODoc",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/conSeaImport/seaConDOorderDocumentation.vue"),
//         },
//         {
//             name: "Tracking(Sea Conso)",
//             path: "/SeaImport/conSeaImportTracking",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/conSeaImport/conSeaImportTracking.vue"),
//         },
//         {
//             name: " EDI Execution",
//             path: "/CCImport/ediExecution",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/ediExecution.vue"),
//         },
//         {
//             name: " EDI Execution New",
//             path: "/CCImport/newEdiExecution",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/newEdiExecution.vue"),
//         },
//         // Added By Priyanshu Singh Start
//         {
//             name: "SHIPPING LINE PAYMENT(INVOICE WISE) CC Export",
//             path: "/CCImport/ccSLinePaymentExportN",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/ccSLinePaymentExportN.vue"),
//         }, {
//             name: "SHIPPING LINE PAYMENT(INVOICE WISE) CC Import",
//             path: "/CCImport/ccSLinePaymentImportN",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/ccSLinePaymentImportN.vue"),
//         }, {
//             name: "SHIPPING LINE PAYMENT(INVOICE WISE) FF Import",
//             path: "/seaImport/ffSLinePaymentImportN",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/seaImport/ffSLinePaymentImportN.vue"),
//         },

//         {
//             name: "SHIPPING LINE PAYMENT(INVOICE WISE) FF Export",
//             path: "/freightForward/ffSLinePaymentExportN_VP",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/ffSLinePaymentExportN_VP.vue"),
//         },


//         {
//             name: "SHIPPING LINE PAYMENT(INVOICE WISE) FF Consolidation Export",
//             path: "/freightForward/ffConSLinePaymentExport_VP",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/ffConSLinePaymentExport_VP.vue"),
//         },
//         {
//             name: "Misc Invoice Sline Payment",
//             path: "/misc/miscInvoiceSlinePayment_VP",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/miscInvoiceSlinePayment_VP.vue"),
//         },
//         {
//             name: "CC Import Assignment Details ",
//             path: "/CCExport/slinePayDash",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/ccslinePaymentDetailsDash.vue"),
//         },
//         {
//             name: "Sline Payment Import Assignment Details ",
//             path: "/Import/SlinePaymentImportDashboard",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/SlinePaymentImportDashboard.vue"),
//         },
//         {
//             name: "Expenses Details ",
//             path: "/allModule/Expenses",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/Expenses.vue"),
//         },
//         {
//             name: "Additional Task Details ",
//             path: "/allModule/AdditionalTask",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/AdditionalTask.vue"),
//         },

//         {
//             name: "Freight MANIFESTATION Details ",
//             path: "/freightForwarding/sendManifestation",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/ffManifestation.vue"),
//         },
//         {
//             name: "Freight Import MANIFESTATION Details ",
//             path: "/seaImport/sendManifestation",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/seaImport/ffManifestation.vue"),
//         },
//         {
//             name: "Freight Consolidation MANIFESTATION Details ",
//             path: "/ffExportCon/ffconsendManifestation",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/ffExportCon/ffconManifestation.vue"),
//         },
//         {
//             name: "Expense Payment Dashboard Details ",
//             path: "/Expense/expPaymentDash",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/ExpensePaymentDashboard.vue"),
//         },
//         // Added By Priyanshu Singh End
//         // {
//         //   name: "CC Import Tally",
//         //   path: "/CCImport/CCInvoiceForTallyImport",
//         //   meta: {
//         //     auth: true
//         //   },
//         //   component: require("../component/CCImport/CCInvoiceForTallyImport.vue")
//         // },
//         {
//             name: "CC Export Tally",
//             path: "/CCImport/CCInvoiceForTallyExport",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/CCInvoiceForTallyExport.vue"),
//         },
//         {
//             name: "CC Export Import Doc ",
//             path: "/CCImport/ccDocListPage/:ccExportId/:ccType",
//             component: require("../component/CCImport/ccDocListPage.vue"),
//         },

//         {
//             name: " Execution CC",
//             path: "/CCImport/ExecutionImport",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/ExecutionImport.vue"),
//         },
//         {
//             name: " Tracking CC Import",
//             path: "/CCImport/ccImportTracking",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/ccImportTracking.vue"),
//         },

//         {
//             name: "Handover to Rail & Rail Out",
//             path: "/CCImport/ccHandoverToRail",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/ccHandoverToRail.vue"),
//         },
//         {
//             name: "Handover to Rail & Rail Out New",
//             path: "/CCImport/newCCHandoverToRail",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/newCCHandoverToRail.vue"),
//         },

//         {
//             name: "CC Export VGM",
//             path: "/CCImport/ccExVgm",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/ccExVgm.vue"),
//         },
//         {
//             name: "CC Export VGM New",
//             path: "/CCImport/newCCExVgm",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/newCCExVgm.vue"),
//         },

//         {
//             name: "CC Payment Detail",
//             path: "/CCImport/paymentDetail",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/paymentExport.vue"),
//         },
//         {
//             name: "Enquiry Form",
//             path: "/mainEnquiry/mainEnquiry",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/mainEnquiry.vue"),
//             finalPagePermision: "",
//         },

//         {
//             name: "CC Export BL",
//             path: "/CCImport/ccExBL",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/ccExBL.vue"),
//         },
//         {
//             name: "CC Export BL",
//             path: "/CCImport/ccExBL",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/ccExBL.vue"),
//         },
//         {
//             name: "User Profile",
//             path: "/userManagement/userProfile",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/view/userManagement/userProfile.vue"),
//         },
//         {
//             name: "CC-Import Entry",
//             path: "/CCImport/CCImportEntry",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/CCImportEntry.vue"),
//         },
//         {
//             name: "CC-Import Entry New",
//             path: "/CCImport/newCCImportEntry",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/newCCImportEntry.vue"),
//         },

//         {
//             name: "CC-Export Entry",
//             path: "/CCImport/CCExportEntry",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/CCExportEntry.vue"),
//         },
//         {
//             name: "CC-Export Entry New",
//             path: "/CCImport/newCCExportEntry",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/CCImport/newCCExportEntry.vue"),
//         },
//         {
//             name: "Air Import",
//             path: "/airImport/ffairImportFcl",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/airImport/ffairImportFcl.vue"),
//         },
//         {
//             name: "Air Export",
//             path: "/airFreight/airFFExportConsol",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/airFreight/airFFExportConsol.vue"),
//         },
//         {
//             name: "Air Invoice",
//             path: "/airFreight/airFreightInvoice",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/airFreight/airFreightInvoice.vue"),
//         },
//         {
//             name: "Air Invoice Imp",
//             path: "/airImport/airFreightImportInvoice",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/airImport/airFreightImportInvoice.vue"),
//         },

//         {
//             name: "Normal Sea Import",
//             path: "/seaImport/ffseaImportFcl",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/seaImport/ffseaImportFcl.vue"),
//         },
//         {
//             name: "Normal Sea Import New",
//             path: "/seaImport/newFFseaImportFcl",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/seaImport/newFFseaImportFcl.vue"),
//         },

//         {
//             name: "Conso Sea Import",
//             path: "/conSeaImport/ffConSeaImportFcl",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/conSeaImport/ffConSeaImportFcl.vue"),
//         },
//         {
//             name: "Service Estimation",
//             path: "/serviceEstimation/serviceEstimation",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/maintenance/serviceEstimation/serviceEstimation.vue"),
//         },
//         {
//             name: "Po Order",
//             path: "/poOrder/poOrder",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/maintenance/poOrder/poOrder.vue"),
//         },
//         {
//             name: "Stock-In",
//             path: "/stockIn",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/maintenance/stockIn/stockIn.vue"),
//         },
//         {
//             name: " Normal Sea Export ",
//             path: "/freightForward/ffExportFcl",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/ffExportFcl.vue"),
//         },
//         {
//             name: " Normal Sea Export New",
//             path: "/freightForward/newFFExportFcl",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/freightForwarding/newFFExportFcl.vue"),
//         },
//         {
//             name: "FF Export Import Doc ",
//             path: "/freightForwarding/ffDocListPage/:ffExportFclId/:type",
//             component: require("../component/freightForwarding/ffDocListPage.vue"),
//         },

//         {
//             name: "Conso-Sea Export ",
//             path: "/ffExportCon/ffExportFclConsolidation",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/ffExportCon/ffExportFclConsolidation.vue"),
//         },
//         {
//             name: "Toll Charges",
//             path: "/toll/tollCharges",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/view/tollMaster/tollCharges.vue"),
//         },
//         {
//             name: "Add New User",
//             path: "/userManagement/addUser",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/view/userManagement/addUser.vue"),
//         },
//         {
//             name: "Add New Vendor",
//             path: "/vendorMaster/vendorMaster",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/view/vendorMaster/vendorMaster.vue"),
//         },
//         {
//             name: "Container",
//             path: "/container/containerType",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/view/containerMaster/containerType.vue"),
//         },
//         {
//             name: " Add New Driver",
//             path: "/vehicle/driverMaster",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/view/driverMaster/driverMaster.vue"),
//         },
//         {
//             name: "Add New Vehicle",
//             path: "/vehicle/truckMaster",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/view/vehicleMaster/truckMaster.vue"),
//         },
//         {
//             name: "Add Client",
//             path: "/client/addClient",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/view/clients/addClient.vue"),
//         },
//         {
//             name: "Gate-In",
//             path: "/yard/GateIn",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/yard/GateIn.vue"),
//         },
//         {
//             name: "Gate-Out",
//             path: "/yard/gateOut",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/yard/gateOut.vue"),
//         },
//         {
//             name: "Enquiry Form",
//             path: "/sales/leads",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/view/sales/leadsBooking.vue"),
//         },

//         {
//             name: "Assignment",
//             path: "/allModuleForm/allModuleForm",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/allModuleForm.vue"),
//         },
//         {
//             name: "Transportation Form",
//             path: "/sales/salesBooking",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/view/sales/salesBookingForm.vue"),
//             finalPagePermision: "",
//         },
//         {
//             name: "Quotation Form TPT",
//             path: "/mainEnquiry/mainEnqQuotation",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/mainEnqQuotation.vue"),
//             finalPagePermision: "",
//         },
//         {
//             name: "Quotation Form FF",
//             path: "/mainEnquiry/mainEnqQuotationFF",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/mainEnqQuotationFF.vue"),
//             finalPagePermision: "",
//         },
//         {
//             name: "Quotation Form CC",
//             path: "/mainEnquiry/mainEnqQuotationCC",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/mainEnqQuotationCC.vue"),
//             finalPagePermision: "",
//         },
//         {
//             name: "Quotation CC Details",
//             path: "/mainEnquiry/viewMainEnqQuotationCC",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/viewMainEnqQuotationCC.vue"),
//             finalPagePermision: "",
//         },
//         {
//             name: "Quotation FF Details",
//             path: "/mainEnquiry/viewMainEnqQuotationFF",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/viewMainEnqQuotationFF.vue"),
//             finalPagePermision: "",
//         },
//         {
//             name: "Quotation TPT Details",
//             path: "/mainEnquiry/viewMainEnqQuotationTPT",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/viewMainEnqQuotationTPT.vue"),
//             finalPagePermision: "",
//         },
//         {
//             name: "Seale Execution",
//             path: "/mainEnquiry/salesExecutionAll",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/salesExecutionAll.vue"),
//             finalPagePermision: "",
//         },
//         {
//             name: "Misc Sales Execution",
//             path: "/mainEnquiry/miscSalesExecutionAll",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/miscSalesExecution.vue"),
//             finalPagePermision: "",
//         },
//         // {
//         //   name: "miscellaneous Execution",
//         //   path: "/mainEnquiry/miscellaneousExecutionAll",
//         //   meta: {
//         //     auth: true,
//         //   },
//         //   component: require("../component/allModuleForm/miscellaneousExecutionAll.vue"),
//         //   finalPagePermision: "",
//         // },

//         {
//             name: "Status Track Internal",
//             path: "/UpdateStatus/internalAssignStatus",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/clientDashboard/internalAssignStatus.vue"),
//             finalPagePermision: "",
//         },

//         {
//             name: "Client Chat",
//             path: "/UpdateStatus/clientChatScreen",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/clientDashboard/clientChatScreen.vue"),
//             finalPagePermision: "",
//         },

//         {
//             name: "LEDGER MASTER",
//             path: "/LEDGERMASTER/ledgerMaster",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/view/LEDGERMASTER/ledgerMaster.vue"),
//         },
//         {
//             name: "Test Assignment Details ",
//             path: "/freightForward/slinePayNew",
//             meta: {
//                 auth: true,
//             },
//             // component: require("../component/freightForwarding/slinePaymentDetails.vue"),
//             component: require("../component/freightForwarding/slinePaymentDetailsNew.vue"),
//         },

//         {
//             name: "Assignment Tracking",
//             path: "/assignment/tracking",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/allModuleForm/globalAssignmentTracking.vue"),
//         },
//         {
//             name: "Error 404",
//             path: "*",
//             meta: {
//                 auth: true,
//             },
//             component: require("../component/view/errorPage/error.vue"),
//         },



//         //import all sidebar items route
//         ...getSidebarRoutes(),
//     ],
// });

// function getSidebarRoutes(menu = [], routes = [], isBaseRouting = true) {
//     if (menu.length < 1 && isBaseRouting) {
//         const { sideBarItems } = require("../sidebar");
//         menu = sideBarItems || [];
//     }

//     for (let i = 0, l = menu.length; i < l; i++) {
//         const item = menu[i];
//         if (item.path) {
//             routes.push(item);
//         }
//         if (!item.component) {
//             //since we are pushing items in array we don't need to return this fucntion.
//             getSidebarRoutes(item.children, routes, false);
//         }
//     }
//     return routes;
// }


// WEBPACK FOOTER //
// ./src/route/index.js